module.exports = __webpack_public_path__ + "img/my_bg01@3x.b5f2ec83.png";